<script setup lang="ts">
/**
 *
 *  Props and emits section
 *
 *
 */

const props = defineProps<{
    color?: string
    size?: string
    tooltip?: string
}>()

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */

/**
 *
 *  Life cicle events
 *
 *
 */

/**
 *
 *  Functions section
 *
 *
 */
</script>

<template>
    <div>
        <q-spinner-ios :color="color || 'primary'" :size="size || '2em'" />
        <div v-if="tooltip">
            <q-tooltip :offset="[0, 8]">{{ tooltip }}</q-tooltip>
        </div>
    </div>
</template>

<style scoped></style>
